import type { AxiosRequestConfig } from 'axios'

import qs from 'qs'

// 存储每个请求的标识和对应的 AbortController
let pendingMap = new Map<string, AbortController>()

export function getPendingUrl(config: AxiosRequestConfig) {
    return [config.method, config.url, qs.stringify(config.data), qs.stringify(config.params)].join('&')
}

export class AxiosCanceler {
    /**
     * 添加请求
     * @param {object} config
     */
    addPending(config: AxiosRequestConfig) {
        this.removePending(config)
        const url = getPendingUrl(config)
        // 使用 AbortController 替代已废弃的 CancelToken，避免 axios 1.16+ 取消行为变化导致的空响应问题
        if (!config.signal) {
            const controller = new AbortController()
            config.signal = controller.signal
            pendingMap.set(url, controller)
        }
    }

    /**
     * @description: 清空所有pending
     */
    removeAllPending() {
        pendingMap.forEach((controller) => {
            controller.abort()
        })
        pendingMap.clear()
    }

    /**
     * 移除请求
     * @param {object} config
     */
    removePending(config: AxiosRequestConfig) {
        const url = getPendingUrl(config)

        if (pendingMap.has(url)) {
            // 如果在 pending 中存在当前请求标识，需要取消当前请求，并且移除
            pendingMap.get(url)?.abort()
            pendingMap.delete(url)
        }
    }

    /**
     * @description: 重置
     */
    reset(): void {
        pendingMap = new Map<string, AbortController>()
    }
}
